
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NavigationItem',
  props: {
    children: {
      type: Array,
      default: () => []
    },
    path: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    light: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    className: { type: String, default: '' },
    callBack: {
      type: Function,
      default: () => {
        return null
      }
    }
  }
})
